



























import Vue from 'vue';
import { Component, Mixins, Prop } from 'vue-property-decorator';

import FullTemplate from '@/shared/components/Template/Full.vue';
import FeedbackInfo from '@/shared/components/FeedbackInfo/FeedbackInfo.vue';

import StepControllerMixin from '@/shared/mixins/StepControllerMixin';

import { ECheckoutStep } from '@/helpers/enums';

@Component({
  components: {
    FullTemplate,
    FeedbackInfo
  }
})
export default class PageFeedback extends Mixins(StepControllerMixin) {
  @Prop({ default: 'success' }) private type: string;
  @Prop({ default: true }) private fillHeight: boolean;
  @Prop() private icon: string;
  @Prop() private title: string;
  @Prop() private message: string;
  @Prop() private buttonLabel: string;
  @Prop({ default: 'primary' }) private buttonColor: string;
  @Prop({ default: true }) private showButton: boolean;

  private get screenSize(): string {
    return this.$vuetify.breakpoint.name;
  }
}
